import { Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { lang } from "../../i18nLang";
import { ContractStore } from "../../store";
import DialogModal from "../UI/DialogModals";

interface IProps {
  /** Propriedade que indica se o modal está aberto ou fechado. */
  open: boolean;
  /** Função que será chamada ao fechar o modal */
  onClose: () => void;
}

const ContractDelete = ({ open, onClose }: IProps) => {
  const history = useHistory();

  const handleConfirm = () => {
    setTimeout(deleteContract, 500);
  };

  function deleteContract() {
    ContractStore.deleteContract().then((deleted) => {
      if (deleted) history.push("/kanban");
    });
  }

  return (
    <DialogModal
      title={lang("contract.deleteContractTitle")}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      confirmLabel={lang("delete")}
      typeConfirm="error"
    >
      <Typography variant="body1">{lang("contract.deleteMessage")}</Typography>
    </DialogModal>
  );
};

export default ContractDelete;
